module.exports = __webpack_public_path__ + "static/apollo11-1fbb731e85a28e17563edc46cace9e03.jpg";